import { ContentArea } from '../version/types';

/**
 * Checks if `id`, `startNodeData`, `endNodeData`, `patternString`, and `parentId` are present on the given `ContentArea` object.
 *
 * @param {ContentArea} contentArea - The `ContentArea` object to be tested for validity.
 * @returns {boolean} Boolean indicating whether the given `ContentArea` object is valid.
 */
const getContentAreaAttributesValid = (contentArea: ContentArea) =>
  (contentArea.id?.length ?? 0) > 0 &&
  (contentArea.startNodeData?.length ?? 0) > 0 &&
  (contentArea.endNodeData?.length ?? 0) > 0 &&
  (contentArea.patternString?.length ?? 0) > 0 &&
  (contentArea.parentId?.length ?? 0) > 0;

/**
 * Ensures no crucial information is lost during calculation processes using {@link getContentAreaAttributesValid}.
 *
 * @param {ContentArea} updatedContentArea - The newly calculated `ContentArea` object.
 * @param {ContentArea} oldContentArea - The original `ContentArea` object containing the initial values.
 * @returns {ContentArea} Either the valid updated `ContentArea` object or the original `ContentArea` object with previous values and `invalid` flag set to true.
 */
const getValidatedContentArea = (
  updatedContentArea: ContentArea,
  oldContentArea: ContentArea,
) => {
  const markAttributesValid = getContentAreaAttributesValid(updatedContentArea);
  if (markAttributesValid) {
    return updatedContentArea;
  }
  return { ...oldContentArea, invalid: true };
};

export default getValidatedContentArea;
